import type { GameWinnerResponse } from '@game/types'
import { useCoreConfig, useQuery, useXmppListener } from '#imports'

export const useGameLatestJackpotWinner = (options?: { lazy: boolean, enabled: boolean }) => {
    const { site } = useCoreConfig()

    const { lazy = true, enabled = true } = options ?? {}

    const query = useQuery<GameWinnerResponse>('/jackpots/get_latest_jackpot_winner', {
        key: 'game:latestJackpotWinner',
        lazy,
        server: !lazy,
        enabled,
        service: 'monolith',
        query: {
            brand: site.brand
        }
    })

    if (import.meta.client) {
        // Set listener to update Latest Jackpot Winner via websocket
        useXmppListener<GameWinnerResponse | undefined>({ kind: 'message', xmlns: 'cego:JackpotWinnerUpdated' }, (result) => {
            if (!result) return
            query.data.value = result
        })
    }

    return query
}
